import { OjWebElement } from '@oracle/oraclejet-webdriver/elements';

/**
 * This is the base class for oj-c-tab-bar-mixed WebElement, and is generated from the
 * component's metadata. Do not modify these contents since they'll be replaced
 * during the next generation.
 * Put overrides into the WebElements's subclass, TabBarMixedWebElement.ts.
 */
export class TabBarMixedWebElementBase extends OjWebElement {
  /**
   * Gets the value of <code>dynamicTabs</code> property.
   * An array of dynamic tabs
   * @return The value of <code>dynamicTabs</code> property.
   *
   */
  public getDynamicTabs(): Promise<Array<DynamicTabs>> {
    return this.getProperty<Array<DynamicTabs>>('dynamicTabs');
  }

  /**
   * Gets the value of <code>dynamicTabsOverflow</code> property.
   * Dynamic tabs overflow configurations
   * @return The value of <code>dynamicTabsOverflow</code> property.
   *
   */
  public getDynamicTabsOverflow(): Promise<string> {
    return this.getProperty<string>('dynamicTabsOverflow');
  }

  /**
   * Gets the value of <code>dynamicTabsOverflowIcon</code> property.
   * The icon used on the overflow tab
   * @return The value of <code>dynamicTabsOverflowIcon</code> property.
   *
   */
  public getDynamicTabsOverflowIcon(): Promise<object> {
    return this.getProperty<object>('dynamicTabsOverflowIcon');
  }

  /**
   * Gets the value of <code>size</code> property.
   * Size of TabBarMixed
   * @return The value of <code>size</code> property.
   *
   */
  public getSizeProperty(): Promise<string> {
    return this.getProperty<string>('size');
  }

  /**
   * Sets the value of <code>selection</code> property.
   * The key of the selected tab
   * @param selection The value to set for <code>selection</code>
   *
   */
  public changeSelection(selection: string | number): Promise<void> {
    return this.setProperty<string | number>('selection', selection);
  }

  /**
   * Gets the value of <code>selection</code> property.
   * The key of the selected tab
   * @return The value of <code>selection</code> property.
   *
   */
  public getSelection(): Promise<string | number> {
    return this.getProperty<string | number>('selection');
  }

  /**
   * Gets the value of <code>separatorPadding</code> property.
   * The padding around the vertical divider that seperates collections of tabs.
   * @return The value of <code>separatorPadding</code> property.
   *
   */
  public getSeparatorPadding(): Promise<string> {
    return this.getProperty<string>('separatorPadding');
  }

  /**
   * Gets the value of <code>staticTabs</code> property.
   * An array of static tabs
   * @return The value of <code>staticTabs</code> property.
   *
   */
  public getStaticTabs(): Promise<Array<StaticTabs>> {
    return this.getProperty<Array<StaticTabs>>('staticTabs');
  }

  /**
   * Gets the value of <code>staticTabsDisplay</code> property.
   * The display configuration for static tabs.
   * @return The value of <code>staticTabsDisplay</code> property.
   *
   */
  public getStaticTabsDisplay(): Promise<string> {
    return this.getProperty<string>('staticTabsDisplay');
  }
}
export interface DynamicTabs {
  /**
   *
   */
  badge: number;
  /**
   *
   */
  icon: object;
  /**
   *
   */
  itemKey: string | number;
  /**
   *
   */
  label: string;
  /**
   *
   */
  tabPanelId: string;
}
export interface StaticTabs {
  /**
   *
   */
  badge: number;
  /**
   *
   */
  icon: object;
  /**
   *
   */
  itemKey: string | number;
  /**
   *
   */
  label: string;
  /**
   *
   */
  tabPanelId: string;
}
